// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "categories-landing-" + (chunkId === 226 ? "webfooter-Footer" : chunkId) + "-st-" + {"213":"cd934693","226":"cd8a9e96","313":"c7adda02","609":"3a380546","790":"2fa43dde","846":"310eaf8f","888":"01ff854c"}[chunkId] + ".js";
};